module.exports = __webpack_public_path__ + "img/52_38.d3e67cae.png";